// src/App.js (updated with NewDashboard + OldDashboard + DSC Test + AdminPortal Fix)
import React, { useState, useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
  useNavigate,
} from "react-router-dom";

// Pages
import LoginPage from "./HomePage/Login";
import AdminPortal from './HomePage/AdminPortal';
import VisitorPage from './HomePage/VisitorPage';

// Admin pages
import Dashboard from "./Role/Dashboardd";
import CreateUser from "./Role/createuser";
import PendingApprovals from './Role/PendingApprovals';
import VisitorsHistory from './Role/VisitorsHistory';
import FormBuilder from "./Role/FormBuilder";
import FormTemplates from "./Role/FormTemplates";
import Workflow from "./Role/Workflow";
import Forms from "./Role/Forms";
import GraphFormsPage from "./Role/GraphFormsPage";
import ReportDashboard from "./Role/ReportDashboard";
import Helpdesk from "./Role/Helpdesk";
import Ticketsystem from "./Role/Ticketsystem";
import Transfer from "./Role/Transfer/Transfer";
import AcceptForms from "./Role/AcceptForms"; 
import UserTransfer from "./Role/UserTransfer";
import NewDashboard from "./Role/NewDashboard";
import DSCTestPage from "./components/DSCTestPage";
// import ChatAI from "./Role/ChatAI";
import FormInstancesView from "./Role/FormInstancesView";
import NotificationPanel from "./Role/NotificationPanel";


import OldFormKPIDashboard from "./Role/dashboard/index";

// Option 2: Give it a clearer name
// import FormKPIDashboard from "./Role/dashboard/index";

/* ========================= */
/* AUTH GUARD - UPDATED TO sessionStorage */
/* ========================= */
function ProtectedRoute() {
  const token = sessionStorage.getItem("token");
  return token ? <Outlet /> : <Navigate to="/login" replace />;
}

/* ========================= */
/* REDIRECT BASED ON ROLE - UPDATED TO sessionStorage */
/* ========================= */
function RoleBasedRedirect() {
  const token = sessionStorage.getItem("token");
  const userRole = sessionStorage.getItem("userRole");
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  // Check user role and redirect accordingly
  if (userRole === "DMA_DESK_OFFICER" || userRole === "DMA") {
    return <Navigate to="/dma-desk/dashboard" replace />;
  } else if (userRole === "ULB" || userRole === "DISTRICT_ADMIN" || userRole === "DIVISIONAL_OFFICER" || userRole === "DAO" || userRole === "RDMA") {
    return <Navigate to="/user/dashboard" replace />;
  } else {
    // Default to NewDashboard for super-admin or any other role
    return <Navigate to="/new-dashboard" replace />;
  }
}

/* ========================= */
/* ADMIN PORTAL WRAPPER COMPONENT */
/* ========================= */
function AdminPortalWrapper() {
  const [showAdminPortal, setShowAdminPortal] = useState(true);
  const navigate = useNavigate();
  
  const handleClose = () => {
    setShowAdminPortal(false);
    // Navigate back to dashboard or login
    const userRole = sessionStorage.getItem("userRole");
    if (userRole === "SUPER_ADMIN" || userRole === "DMA_ADMIN") {
      navigate("/new-dashboard");
    } else {
      navigate("/login");
    }
  };
  
  return (
    <AdminPortal 
      visible={showAdminPortal} 
      onClose={handleClose}
      currentTheme={null}
    />
  );
}

/* ========================= */
/* APP */
/* ========================= */
export default function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!sessionStorage.getItem("token")
  );

  // Listen for storage events to update login state
  useEffect(() => {
    const handleStorageChange = () => {
      setIsLoggedIn(!!sessionStorage.getItem("token"));
    };
    
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* ALWAYS SHOW LOGIN FIRST */}
        <Route path="/" element={<RoleBasedRedirect />} />
        <Route path="/visitor" element={<VisitorPage />} />
        
        {/* LOGIN */}
        <Route
          path="/login"
          element={<LoginPage setIsLoggedIn={setIsLoggedIn} />}
        />
        
        {/* ADMIN PORTAL ROUTE - Only accessible when logged in */}
        <Route element={<ProtectedRoute />}>
          <Route path="/admin-portal" element={<AdminPortalWrapper />} />
        </Route>
        
        {/* OLD DASHBOARD ROUTE (FormKPIDashboard) */}
         <Route element={<ProtectedRoute />}> 
          {/* <Route path="/old-dashboard" element={<OldFormKPIDashboard />} />  */}
          {/* Or if you want to keep the route name as /old-code */}
         <Route path="/old-code" element={<OldFormKPIDashboard />} />
        </Route> 

        {/* PROTECTED ADMIN ROUTES - NEW DASHBOARD */}
        <Route element={<ProtectedRoute />}>
          {/* ✅ NEW DASHBOARD ROUTES */}
          <Route path="/new-dashboard" element={<NewDashboard />} />
          <Route path="/super-admin/new-dashboard" element={<NewDashboard />} />
          <Route path="/dma-desk/dashboard" element={<NewDashboard />} />
          <Route path="/user/dashboard" element={<NewDashboard />} />
          
          <Route path="/dsc-test" element={<DSCTestPage />} />
          
          {/* Other admin routes */}
          <Route path="/super-admin/dashboard" element={<Dashboard />} />
          <Route path="/super-admin/create-user" element={<CreateUser />} />
          <Route path="/pending-approvals" element={<PendingApprovals />} />
          <Route path="/admin/visitors" element={<VisitorsHistory />} />
          <Route path="/super-admin/form-templates" element={<FormTemplates />} />
          <Route path="/super-admin/form-templates/form-builder" element={<FormBuilder />} />
          <Route path="/super-admin/workflow" element={<Workflow />} />
          <Route path="/super-admin/Form-filling" element={<Forms />} />
          <Route path="/super-admin/graphs" element={<GraphFormsPage />} />
          <Route path="/super-admin/reports" element={<ReportDashboard />} />
          <Route path="/super-admin/helpdesk" element={<Helpdesk />} />
          <Route path="/super-admin/ticket-system" element={<Ticketsystem />} />
          <Route path="/super-admin/transfer" element={<Transfer />} />
          <Route path="/super-admin/accept-forms" element={<AcceptForms />} />
          {/* <Route path="/super-admin/chat-ai" element={<ChatAI />} /> */}
          <Route path="/super-admin/user-transfer" element={<UserTransfer />} />
          <Route path="/workflow/form-instances/:formId" element={<FormInstancesView />} />
          <Route path="/notifications" element={<NotificationPanel />} />
        </Route>

        {/* FALLBACK */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}